import React from 'react';
import PropTypes from 'prop-types';
import ShallowRenderedComponent from '../base/ShallowRenderedComponent';
import _ from 'lodash';
import Button from '../markup/Button';
import Input from '../markup/Input';
import $ from 'jquery';
import { validateEmail } from '../../utils/forms';
import UserManager from '../../core/UserManager';
import localized, { messages } from '../../core/i18n';
import { ModalFooter, ModalHeader, Modal } from '../markup/Modal';

class ResetPasswordModal extends ShallowRenderedComponent {

	static propTypes = {
		id: PropTypes.string
	};

	constructor(props) {
		super(props);
		this.state = {
			email: '',
			isPasswordReset: false,
			errors: {},
			...this.state
		};
	}

	componentDidMount() {
		super.componentDidMount();
		const { id } = this.props;
		$('#' + id).on('show.bs.modal', () => {
			this.setState({email: '', errors: {}, isPasswordReset: false})
		});
	}

	componentWillUnmount() {
		const $modal = $('#' + this.props.id);
		$modal.off('show.bs.modal');
		$modal.modal('hide');
		super.componentWillUnmount();
	}

	onChange = () => (event) => {
		this.setState({email: event})
	};

	getErrors = (err) => {
		let error = {};
		if (err.responseStatus === 404) {
			error.email = localized(messages.RESET_PASSWORD.EMAIL_NOT_FOUND)
		}

		return error
	};

	resetPassword = () => {
		const errors = this.validationErrors();
		if (!_.isEmpty(errors)) {
			this.setState({ errors });
			return;
		}

		return UserManager.requestPasswordReset(this.state.email)
			.then(() => {
				this.setState({email: '', isPasswordReset: true});
			})
			.catch(err => {
				const errors = this.getErrors(err);
				this.setState({errors: errors});
				if (_.isEmpty(errors)) {
					this.showErrorModal(localized(messages.RESET_PASSWORD.ERROR_WHILE_RESET), err)
				}
			});
	};

	validationErrors = () => {
		const { email } = this.state;
		const errors = {};
		if (!validateEmail(email)) {
			errors.email = localized(messages.RESET_PASSWORD.PROVIDE_VALID_EMAIL);
		}

		return errors;
	};

	render() {
		const { isPasswordReset, email, errors } = this.state;
		const { id } = this.props;
		return (
			<Modal className="reset-password-modal" id={id} noCloseOutside={true}>
				<ModalHeader>
					<span className="close" data-dismiss="modal" aria-hidden="true">×</span>
					<h4 className="modal-title">{localized(messages.LOGIN_PAGE.FORGOT_PASSWORD)}</h4>
					<div></div>
				</ModalHeader>
				<div style={{overflow: 'visible'}}>
					{!isPasswordReset && <div>
						{localized(messages.RESET_PASSWORD.ENTER_EMAIL)}
						<div>
							<Input maxLength={255} placeholder={localized(messages.LOGIN_PAGE.EMAIL)} error={errors.email} value={email || ''}
								   onChange={this.onChange()}/>
						</div>
					</div>
					}
					{isPasswordReset && <div className="reset-password-info text-center">
						<span className="fa fa-check-circle" />
						{localized(messages.RESET_PASSWORD.RESET_LINK_SENT)}
					</div>}
				</div>
				<ModalFooter>
					{!isPasswordReset ?
						<Button pendingTitle="Please wait..." className="btn-primary center-block" onClick={this.resetPassword}>{localized(messages.RESET_PASSWORD.RESET_BUTTON)}</Button> :
						<Button pendingTitle="Please wait..." className="btn-primary center-block" data-dismiss="modal">{localized(messages.RESET_PASSWORD.OK_BUTTON)}</Button>
					}
				</ModalFooter>
			</Modal>
		);
	}

}

export default ResetPasswordModal;
